// Views
import SpecialCollectionList from '../../views/special-collections/SpecialCollectionsList';
import SpecialCollectionForm from '../../views/special-collections/SpecialCollectionsForm';

import ErrorFallback from '../../views/ErrorFallback';

// Components
import ProtectedRoute from '../ProtectedRoute';

/**
 *  @type {Route[]}
 */
export const specialCollectionsPrivateRoutes = [
  {
    path: '/special-collections',
    element: <ProtectedRoute><SpecialCollectionList /></ProtectedRoute>,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/special-collections/:specialCollectionId',
    element: <ProtectedRoute><SpecialCollectionForm /></ProtectedRoute>,
    errorElement: <ErrorFallback />,
  },
];
